import axios from './axios';
import { Comment, CommentThread } from '../store/config/types/comment.types';

async function getCommentThread(entity: string, entityId: number): Promise<CommentThread> {
  const res = await axios.get(`/comments/${entity}/${entityId}`);
  return res.data.data;
}

async function addCommentToThread(commentThreadId: number, text: string): Promise<Comment> {
  const res = await axios.post(`/comments/${commentThreadId}`, { text });
  return res.data.data;
}

async function markAsRead(commentId: number | number[]): Promise<void> {
  await axios.patch(`/comments/mark-as-read`, { commentId });
}

const CommentService = {
  getCommentThread,
  addCommentToThread,
  markAsRead,
};

export default CommentService;
